import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import DCard from "../../components/card/DCard";
import DCardHeader from "../../components/card/DCardHeader";
import DCardBody from "../../components/card/DCardBody";
import Select from "react-select";
import InputMask from "react-input-mask";
import { Table } from "react-bootstrap";

import { previousTreatments } from "../../../enum/enums";

const PreviousTreatmentCard = props => {
    const {
        children,
        className,
        //
        onRequestAdd,
        previousTreatmentsListParm,
        ...attributes
    } = props;

    const [previousTreatmentsList, setPreviousTreatmentsList] = useState(previousTreatmentsListParm);
    const [type, setType] = useState(null);
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [idRowEditing, setIdRowEditing] = useState(undefined);

    useEffect(() => {
        setPreviousTreatmentsList(previousTreatmentsListParm);
    }, [previousTreatmentsListParm]);

    function handleAddPreviousTreatment() {
        if (!isEditing) {
            const newPreviousTreatmentItem = {
                id: (Math.floor(Math.random() * 65536)).toString(),
                type,
                month,
                year
            };

            const newPreviousTreatmentsList = [...previousTreatmentsList, newPreviousTreatmentItem];
            setPreviousTreatmentsList(newPreviousTreatmentsList);
            onRequestAdd(newPreviousTreatmentsList);
        } else {
            const newPreviousTreatmentsList = previousTreatmentsList.map(previousTreatmentItem => {
                if (previousTreatmentItem.id === idRowEditing) {
                    return {
                        id: previousTreatmentItem.id,
                        type,
                        month,
                        year
                    }
                }

                return previousTreatmentItem;
            })
            setPreviousTreatmentsList(newPreviousTreatmentsList);
            onRequestAdd(newPreviousTreatmentsList);
        }

        resetFields();
    }

    function handleEditPreviousTreatment(id) {
        const editRowInfo = previousTreatmentsList.find(x => x.id === id);
        if (editRowInfo) {
            setType(editRowInfo.type);
            setMonth(editRowInfo.month);
            setYear(editRowInfo.year);

            setIdRowEditing(id);
            setIsEditing(true);
        }
    }

    function handleDeletePreviousTreatments(id) {
        const newPreviousTreatmentsList = previousTreatmentsList.filter(x => x.id !== id);
        setPreviousTreatmentsList(newPreviousTreatmentsList);
        onRequestAdd(newPreviousTreatmentsList);
    }

    function resetFields() {
        setType(null);
        setMonth("");
        setYear("");

        setIsEditing(false);
        setIdRowEditing(undefined);
    }

    return (
        <>
            <DCard borderColor="light">
                <DCardHeader color="light" textColor="dark">Tratamentos Prévios</DCardHeader>
                <DCardBody>
                    <div className="basic-form">
                        <div className="row">
                            <div className="form-group mb-3 col-md-6">
                                <label><small>Selecione o tratamento</small></label>
                                <Select
                                    isClearable
                                    defaultValue={type}
                                    value={type}
                                    onChange={(e) => setType(e)}
                                    options={previousTreatments}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            height: 45,
                                            backgroundColor: state.isDisabled ? "#dde0e3" : ""
                                        }),
                                    }}
                                    placeholder="Selecione..."
                                />
                            </div>
                            <div className="form-group mb-3 col-md-2">
                                <label><small>Mês</small></label>
                                <InputMask
                                    mask="99"
                                    maskChar=" "
                                    value={month}
                                    onChange={(event) => {
                                        if (event.target.value.length !== 2) return false;
                                        setMonth(event?.target.value);
                                    }}
                                    alwaysShowMask={true}
                                >
                                    {(inputProps) => <input {...inputProps} type="text" className="form-control" />}
                                </InputMask>
                            </div>
                            <div className="form-group mb-3 col-md-2">
                                <label><small>Ano</small></label>
                                <InputMask
                                    mask="9999"
                                    maskChar=" "
                                    value={year}
                                    onChange={(event) => {
                                        if (event.target.value.length !== 4) return false;
                                        setYear(event?.target.value);
                                    }}
                                    alwaysShowMask={true}
                                >
                                    {(inputProps) => <input {...inputProps} type="text" className="form-control" />}
                                </InputMask>
                            </div>
                            <div className="form-group mb-3 col-md-2">
                                <button className="btn btn-primary shadow mt-4 ms-1" onClick={handleAddPreviousTreatment}>
                                    <i className="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group mb-3 col-md-12" hidden={previousTreatmentsList.length === 0}>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                                <strong>Tratamento</strong>
                                            </th>
                                            <th>
                                                <strong>Mês</strong>
                                            </th>
                                            <th>
                                                <strong>Ano</strong>
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            previousTreatmentsList.map((previousTreatmentItem) => {
                                                return (
                                                    <tr key={previousTreatmentItem.id}>
                                                        <td>{previousTreatmentItem.type.label}</td>
                                                        <td>{previousTreatmentItem.month}</td>
                                                        <td>{previousTreatmentItem.year}</td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <button
                                                                    className="btn btn-info shadow sharp ms-1"
                                                                    onClick={() => handleEditPreviousTreatment(previousTreatmentItem.id)}
                                                                    disabled={isEditing}
                                                                >
                                                                    <i className="fas fa-pencil-alt"></i>
                                                                </button>
                                                                <button
                                                                    className="btn btn-danger shadow sharp ms-1"
                                                                    onClick={() => handleDeletePreviousTreatments(previousTreatmentItem.id)}
                                                                    disabled={isEditing}
                                                                >
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                </DCardBody>
            </DCard>
        </>
    )
}

PreviousTreatmentCard.propTypes = {
    children: PropTypes.node,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    //
    innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};

PreviousTreatmentCard.defaultProps = {
    previousTreatmentsListParm: []
};

export default PreviousTreatmentCard;